import Icon from '../../components/Icon.vue'

Icon.register({"brands/lastfm":{"width":512,"height":512,"paths":[{"d":"M225.8 367.1L207 316.1S176.5 350.1 130.8 350.1C90.3 350.1 61.6 314.9 61.6 258.6 61.6 186.5 98 160.7 133.7 160.7 200.2 160.7 208.5 214 234.6 295.6 253.4 352.5 288.6 398.2 390 398.2 462.7 398.2 512 375.9 512 317.3 512 244.4 449.3 236.7 397 225.2 371.2 219.3 363.6 208.8 363.6 191.2 363.6 171.3 379.4 159.5 405.2 159.5 433.4 159.5 448.6 170.1 450.9 195.3L509.5 188.3C504.8 135.5 468.4 113.8 408.6 113.8 355.8 113.8 304.2 133.7 304.2 197.7 304.2 237.6 323.6 262.8 372.2 274.5 417.1 285.1 452 288.3 452 320.2 452 341.9 430.9 350.7 391 350.7 331.8 350.7 307.1 319.6 293.1 276.8 261.1 180 249.5 113.8 131.8 113.8 45.7 113.8 0 168.3 0 261 0 350.1 45.7 398.2 127.9 398.2 194.1 398.2 225.8 367.1 225.8 367.1z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/lastfm.js
// module id = FRFe
// module chunks = 0